/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CreationMethod {
    IMPORT = 'IMPORT',
    INCIDENT = 'INCIDENT',
    MANUAL = 'MANUAL',
    MOBILE_OPERATOR = 'MOBILE_OPERATOR'
}

